import { useQuery } from "@tanstack/react-query";

import CONSTANTS from "constants/Constants";
import DataJobService from "services/DataJob";

const STATUS = CONSTANTS.DATA_JOB_STATUSES;
const ACTIVE_STATUSES = new Set([STATUS.SCHEDULED, STATUS.IN_PROGRESS]);

// Poll a Meta-leads import DataJob and expose its progress. The worker writes
// its counts under ``info.meta_leads_import``; polling stops once the job
// reaches a terminal status.
export const useMetaLeadsImportJob = jobId => {
  const { data: job } = useQuery({
    queryKey: ["meta-leads-import-job", jobId],
    queryFn: () => DataJobService.getDataJob(jobId),
    enabled: jobId != null,
    retry: false,
    refetchInterval: query =>
      ACTIVE_STATUSES.has(query.state.data?.status) ? 2000 : false,
  });

  const status = job?.status;
  const progress = job?.info?.meta_leads_import;
  const isComplete =
    status === STATUS.COMPLETE || status === STATUS.COMPLETED_WITH_ERRORS;
  const isFailed = status === STATUS.FAILED;
  const isAborted = status === STATUS.ABORTED;

  return { job, status, progress, isComplete, isFailed, isAborted };
};
